(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('Icd10DetailController', Icd10DetailController);

    Icd10DetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Icd10'];

    function Icd10DetailController($scope, $rootScope, $stateParams, entity, Icd10) {
        var vm = this;
        vm.icd10 = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:icd10Update', function(event, result) {
            vm.icd10 = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
